/**
 * @generated SignedSource<<b54da3e303c527d3475eb36119ad66c7>>
 * @relayHash b6520b20ff54c8c3ea703195ce10182f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a4cd88e5db099fd4220fcff8788304192f1e1740250ed308a4e25789bb65beab

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "helpCenterAri"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    v4 = {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    v5 = {
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "helpCenterAri"
    },
    v6 = {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    },
    v7 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "id"
      }, {
        "kind": "ScalarField",
        "name": "title"
      }, {
        "kind": "ScalarField",
        "name": "contentType"
      }, {
        "concreteType": "HelpObjectStoreArticleURLInfo",
        "kind": "LinkedField",
        "name": "urlInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "viewUrl"
        }]
      }],
      "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    },
    v8 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    },
    v9 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v10 = {
      "kind": "ScalarField",
      "name": "cursor"
    },
    v11 = {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "name": "endCursor"
      }, {
        "kind": "ScalarField",
        "name": "hasNextPage"
      }]
    },
    v12 = [v4 /*: any*/, {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }, v5 /*: any*/, v6 /*: any*/];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/],
      "kind": "Fragment",
      "name": "resolvedAndErrorContentQuery",
      "selections": [{
        "alias": "helpObjectStore_searchArticlesForSupportSite",
        "args": [v4 /*: any*/, v5 /*: any*/, v6 /*: any*/],
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "__ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite_connection",
        "plural": false,
        "selections": [{
          "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v7 /*: any*/, v8 /*: any*/, v9 /*: any*/]
          }, v10 /*: any*/]
        }, v11 /*: any*/]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v2 /*: any*/, v3 /*: any*/, v1 /*: any*/],
      "kind": "Operation",
      "name": "resolvedAndErrorContentQuery",
      "selections": [{
        "args": v12 /*: any*/,
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [{
          "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v9 /*: any*/, v7 /*: any*/, v8 /*: any*/]
          }, v10 /*: any*/]
        }, v11 /*: any*/]
      }, {
        "args": v12 /*: any*/,
        "filters": ["cloudId", "helpCenterAri", "input"],
        "handle": "connection",
        "key": "ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite",
        "kind": "LinkedHandle",
        "name": "helpObjectStore_searchArticlesForSupportSite"
      }]
    },
    "params": {
      "id": "a4cd88e5db099fd4220fcff8788304192f1e1740250ed308a4e25789bb65beab",
      "metadata": {
        "connection": [{
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": ["helpObjectStore_searchArticlesForSupportSite"]
        }]
      },
      "name": "resolvedAndErrorContentQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "f6a9a6b6313b3edb981e79b403813589";
export default node;